// React
import React, { useState } from 'react';

// Assets
import images from '../../../assets/img';

// Css
import './index.scss';

const MenuPopup = (props) => {
  const [clickedItem, setClickedItem] = useState(null);

  const handleItemClick = (index) => {
    setClickedItem(index);
    props.onClose();
    props.handleMenuClick(props.menuItems[index]);
  };

  return (
    <div>
      <div className={`menu-popup ${props.isOpen ? 'open' : ''}`}>
        <div className='menu-popup__content'>
          <img
            src={images.closeIcon}
            alt='Close'
            className='menu-popup__content__close-icon'
            onClick={props.onClose}
            tabIndex={0}
            role='button'
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') props.onClose();
            }}
          />
          {props?.menuItems?.map((item, index) => (
            <div
              key={item.id}
              className={`menu-popup__content__item ${clickedItem === index ? 'clicked' : ''}`}
              onClick={() => handleItemClick(index)}
              tabIndex={0}
              role='button'
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ')
                  handleItemClick(index);
              }}
            >
              {item.header}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MenuPopup;
